import { createStore } from 'vuex'
import auth from './auth'
import localization from './localization'
import navigation from './navigation'
import examSetUp from './examSetUp'

export default createStore({
  modules: {
    auth, localization, navigation,examSetUp
  }
})
